import { render, staticRenderFns } from "./DatasetData.vue?vue&type=template&id=7cc5d234&scoped=true"
import script from "./DatasetData.vue?vue&type=script&lang=js"
export * from "./DatasetData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc5d234",
  null
  
)

export default component.exports